module.exports = __webpack_public_path__ + "img/1_021.311b5e9f.jpg";